import React from "react";
import { Card, CardBody } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "./tour-card.css";
import calculateAvgRating from "../utils/avgRating";

const DestCard1 = ({ tour }) => {
  const { id, title, category, city, photo, featured, reviews } = tour;

  const navigate = useNavigate(); // Initialize useNavigate

  const { totalRating, avgRating } = calculateAvgRating(reviews);

  const navigateTotourDetails = (tourName) => {
    navigate(`/destinations/Rajasthan/${tourName.split(" ").join("-").toLowerCase()}`);
  };

  return (
    <div className="tour__card">
      <Card className="mb-4">
        <div className="tour__img">
          <img src={photo} alt="tour-img" />
          {featured && <span>Featured</span>}
        </div>

        <CardBody>
          <div className="card__top d-flex align-items-center justify-content-between">
            <span className="tour__location d-flex align-items-center gap-1">
              <i className="ri-map-pin-line"></i> {city}
            </span>
            {/* <span className="tour__rating d-flex align-items-center gap-1">
              <i className="ri-star-fill"></i>{" "}
              {avgRating === 0 ? null : avgRating}
              {totalRating === 0 ? (
                "Not rated"
              ) : (
                <span>({reviews.length})</span>
              )}
            </span> */}
          </div>
          <h5 className="tour__title">
            <Link
              to={`/destinations/Rajasthan/${title.split(" ").join("-").toLowerCase()}`}
            >
              {title}
            </Link>
          </h5>

          <div className="card__bottom d-flex align-items-center justify-content-between mt-3">
            <button
              
              className="btn booking__btn"
            >
              <Link
                to={`/destinations/Rajasthan/${title.split(" ").join("-").toLowerCase()}`}
              >
                Know more
              </Link>
            </button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default DestCard1;
